import { useCallback } from 'react';
import { useRouter } from 'shared-routing';
import { CATEGORY_ROUTES } from './constants';

export function useCategoryNavigation() {
  const router = useRouter();

  return useCallback(
    (id: string) => {
      const route = CATEGORY_ROUTES[id];
      if (route) router.push({ pathname: route });
    },
    [router]
  );
}
